module.exports = __webpack_public_path__ + "static/img/shangye.307dcad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/shangye.png
// module id = mUN0
// module chunks = 69